import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { isValidURL } from "./Utils"; // Your central validation utility

const LocationValidator = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const currentUrl = window.location.href;
    //console.log('current url : ', currentUrl, isValidURL(currentUrl));

    if (!isValidURL(currentUrl)) {
      // Optionally redirect, show error, or block rendering
      //alert("Invalid URL detected!");
      navigate("/"); // or any safe route
    }
    // Add any other validation logic here
  }, [location, navigate]);

  return null; // This component does not render anything
};

export default LocationValidator;